/*
 * Copyright (c) 2026. Bolmate B.V.
 */

import IDate from '@dvrd/idate';

import Invoice from '../../models/invoiceModel';

import {ISO_DATE_FORMAT} from '../../util/constants';

export type InvoiceDateGroup = {
    /** Stable, locale-independent day key (YYYY-MM-DD) — use as React key. */
    key: string;
    /** Representative date of the group — format this for the date pill. */
    date: IDate;
    invoices: Array<Invoice>;
};

/** Groups a (date-descending) invoice list into per-day buckets, preserving the
 *  list order of both the days and the invoices within each day. */
export function groupInvoicesByDate(invoices: Array<Invoice>): Array<InvoiceDateGroup> {
    const groups = new Map<string, InvoiceDateGroup>();
    for (let ix = 0; ix < invoices.length; ix++) {
        const invoice = invoices[ix];
        // Store index for auto load more feature
        invoice.setTempField('ix', ix);
        const date = invoice.momentDate;
        const key = date.format(ISO_DATE_FORMAT);
        const existing = groups.get(key);
        if (existing) existing.invoices.push(invoice);
        else groups.set(key, {key, date, invoices: [invoice]});
    }
    return Array.from(groups.values());
}
